/**
 * Asynchronously loads the component
 */

import { lazyLoad } from 'utils/loadable';

export const TextFieldAdapter = lazyLoad(
  () => import('./index'),
  module => module.TextFieldAdapter,
);
